import PromoBYDAtto3 from "../../../images/promo/may26/PromoBYDAtto3.png";
import PromoBYDAtto3Mobile from "../../../images/promo/may26/PromoBYDAtto3Mobile.png";
import PromoBYDSealion5 from "../../../images/promo/may26/PromoBYDSealion5.png";
import PromoBYDSealion5Mobile from "../../../images/promo/may26/PromoBYDSealion5Mobile.png";
import PromoTeslaYL from "../../../images/promo/may26/PromoTeslaYL.png";
import PromoTeslaYLMobile from "../../../images/promo/may26/PromoTeslaYLMobile.png";
import PromoTeslaY from "../../../images/promo/may26/PromoTeslaY.png";
import PromoTeslaYMobile from "../../../images/promo/may26/PromoTeslaYMobile.png";
import PromoZeekr from "../../../images/promo/may26/PromoZeekrX.png";
import PromoZeekrMobile from "../../../images/promo/may26/PromoZeekrXMobile.png";
import PromoJaecooJ7 from "../../../images/promo/may26/PromoJaecooJ7.png";
import PromoJaecooJ7Mobile from "../../../images/promo/may26/PromoJaecooJ7Mobile.png";
import PromoMGU9 from "../../../images/promo/may26/PromoMGU9.png";
import PromoMGU9Mobile from "../../../images/promo/may26/PromoMGU9Mobile.png";
import PromoMercedes from "../../../images/promo/may26/PromoMercedes.png";
import PromoMercedesMobile from "../../../images/promo/may26/PromoMercedesMobile.png";
import PromoPolestar from "../../../images/promo/may26/PromoPolestar.png";
import PromoPolestarMobile from "../../../images/promo/may26/PromoPolestarMobile.png";

const dataSlider = (hidePartnered) => [
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: true,
        hideBanner: hidePartnered, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: "",
        imageMobile: "",
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle: "BYD Atto 1, Atto 2, Atto 3, Dolphin, Seal and Sealion 7",
        vehicleSubTitle:
            "5% discount on base price for orders placed between 1st March to 30th June 2026, and delivered by 31st July 2026!",
        priceDollar: "115",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Offer available on new vehicles... (NSW, $100k salary, 15k km/yr)",
        termsLinkUrl: "",
        image: PromoBYDAtto3,
        imageMobile: PromoBYDAtto3Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle:
            "BYD Sealion 5, Sealion 6, Sealion 8, Shark 6 (Premium only)",
        vehicleSubTitle:
            "$3,000 cashback for orders placed between 1st April to 30th June 2026, and delivered by 30th June 2026!",
        priceDollar: "191",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Offer available on new vehicles... (NSW, $100k salary, 15k km/yr)",
        termsLinkUrl: "",
        image: PromoBYDSealion5,
        imageMobile: PromoBYDSealion5Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "New 6 Seater Option",
        vehicleTitle: "Tesla Model Y L Premium",
        vehicleSubTitle: "Highlight: 6 seater & 681km range",
        priceDollar: "263",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Weekly price assumes a 5 year lease... (NSW, $100k salary, 15k km/yr)",
        termsLinkUrl: "",
        image: PromoTeslaYL,
        imageMobile: PromoTeslaYLMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Tesla Model Y Premium RWD",
        vehicleSubTitle: "",
        priceDollar: "219",
        priceCents: "",
        period: "weekly*",
        disclaimerText:
            "* Weekly price assumes a 5 year lease... (NSW, $100k salary, 15k km/yr)",
        termsLinkUrl: "",
        image: PromoTeslaY,
        imageMobile: PromoTeslaYMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle: "Zeekr X",
        vehicleSubTitle:
            "Complementary 7kW AC Home Charger, premium paint, interior options, +2 yrs warranty, 2 yrs Roadside Assistance. Orders by 31st May 2026!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "* Offer available to eligible customers. Terms apply.",
        termsLinkUrl: "",
        image: PromoZeekr,
        imageMobile: PromoZeekrMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle: "Jaecoo models",
        vehicleSubTitle:
            "9% to 10% discounts on various models ordered between 1st May and 30th June 2026 (or until stock runs out)!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to customers who order/take delivery prior to 30th June 2026.",
        termsLinkUrl: "",
        image: PromoJaecooJ7,
        imageMobile: PromoJaecooJ7Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "New Offer",
        vehicleTitle: "MG U9 and QS",
        vehicleSubTitle:
            "Free scheduled servicing - 5yrs/70,000km (BGU9) or 3yrs/45,000km (MGQS). Orders between 1st April to 30th June 2026.",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available on new and demo vehicles (conditions apply).",
        termsLinkUrl: "",
        image: PromoMGU9,
        imageMobile: PromoMGU9Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle:
            "Mercedes-Benz EQA 250+, GLC200 Avantgarde and C300 AMG Line Plus Edition",
        vehicleSubTitle:
            "National drive-away campaign and cash savings. Orders 1st May - 30th June; Delivery by 31st July 2026!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "* Offer available to eligible customers. Terms apply.",
        termsLinkUrl: "",
        image: PromoMercedes,
        imageMobile: PromoMercedesMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "EOFY Offer",
        vehicleTitle: "Polestar 2, 4",
        vehicleSubTitle:
            "12% to 16% discounts on vehicles ordered between 1st April and 30th June 2026 (or until stock runs out)!",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText:
            "* Offer available to customers who order/take delivery prior to 30th June 2026.",
        termsLinkUrl: "",
        image: PromoPolestar,
        imageMobile: PromoPolestarMobile,
    },
];

export default dataSlider;
